import { GridColumnMenuProps } from '@mui/x-data-grid-pro';
import React from 'react';
import CustomFilterItem from './CustomFilters/CustomFilterItem';
import StyledDataGridMenu from './Styled/StyledDataGridMenu';

export default (props: GridColumnMenuProps) => {
    return (
        <StyledDataGridMenu
            {...props}
            slots={{
                columnMenuFilterItem: CustomFilterItem,
            }}
        />
    );
};
